import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function BridgeSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation(0.2);
  return <section ref={ref} className={`w-full py-10 md:py-12 lg:py-20 px-6 md:px-12 lg:px-20 bg-gradient-to-b from-brand-cream to-white border-b border-gray-200 text-center scroll-animate ${isVisible ? 'visible' : ''}`} data-id="element-18">
      <div className="max-w-[700px] mx-auto" data-id="element-19">
        <h2 className="text-[20px] md:text-[24px] lg:text-[28px] font-bold text-brand-teal leading-[1.4] tracking-[-0.3px] mb-8" data-id="element-20">
          These 6 Mechanisms Are Happening Simultaneously—Every Single Shower
        </h2>

        <div className="text-[16px] text-brand-navy font-normal leading-[1.8] space-y-4 tracking-[0.3px]" data-id="element-21">
          <p data-id="element-22">
            Each of these six mechanisms is active during{' '}
            <strong data-id="element-23">every bath</strong>.{' '}
            <span className="emphasis-hover" title="(Sarah: That's right)" data-id="element-24">
              You <strong data-id="element-25">can't cream your way</strong>
            </span>{' '}
            past chlorine gas entering opened pores. You can't soap your way
            past hard water mineral buildup. You can't restrict diet for a
            problem that's <strong data-id="element-26">primarily chemical</strong>. You can't fix it
            by bathing less frequently (you tried that). You can't fix it with
            better technique (you're <strong data-id="element-27">doing it right</strong>).
          </p>
          <p data-id="element-28">
            This isn't a product problem. This isn't a parenting problem. This
            isn't a genetic problem. This is a{' '}
            <span className="emphasis-hover" title="(Jessica: Finally)" data-id="element-29">
              <strong data-id="element-30">water chemistry problem</strong>
            </span>
            .
          </p>
          <p data-id="element-31">
            <span className="emphasis-hover" title="(Michelle: Logical completion)" data-id="element-32">
              <strong data-id="element-33">The good news?</strong>
            </span>{' '}
            Once you understand the mechanism, the solution becomes{' '}
            <strong data-id="element-34">obvious</strong>. Removing chlorine AND neutralizing hard
            minerals <strong data-id="element-35">before</strong> the water touches your child's skin{' '}
            <span className="emphasis-hover" data-id="element-36">
              <strong data-id="element-37">stops the damage at the source</strong>
            </span>
            .
          </p>
        </div>
      </div>
    </section>;
}